import { forwardRef, useCallback, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { APP_NAME } from '@myme/utils';
import { useTranslation } from 'src/hooks';
import { track } from 'src/utils';
import { PageProps } from './types';

// eslint-disable-next-line react/prop-types
export const Page = forwardRef<HTMLDivElement, PageProps>(({ title, children }, ref) => {
  const { t } = useTranslation();
  const location = useLocation();

  const sendPageViewEvent = useCallback(() => {
    track.pageview({
      page_path: location.pathname
    });
  }, []);

  useEffect(() => {
    sendPageViewEvent();
  }, [sendPageViewEvent]);

  return (
    <div ref={ref} style={{ height: '100%' }}>
      <Helmet>
        <title>{`${t(title)} | ${APP_NAME}`}</title>
      </Helmet>
      {children}
    </div>
  );
});
